import React, { useEffect, useState } from 'react';
import Compressor from 'compressorjs';
import axios from 'axios';

const useFileHandleS3 = (file = null, upKey = null, delKey = null) => {
  const [progress, setProgress] = useState(0);
  const [fileUrl, setFileUrl] = useState('');
  const [fileKey, setFileKey] = useState('');
  const [uploadFile, setUploadFile] = useState(null);
  const [deleteFileKey, setDeleteFile] = useState(null);

  useEffect(() => {
    setUploadFile(file);
    setDeleteFile(delKey);
    setProgress(0);
  }, [file, delKey]);

  // 🔴 Delete from backend
  const handleDelete = async (key) => {
    try {
      await axios.post('/api/delete-image', { key }); // adjust if you have a DELETE route
      console.log('File deleted:', key);
    } catch (err) {
      console.error('Failed to delete image:', err);
    }
  };

  if (deleteFileKey) {
    handleDelete(deleteFileKey);
    setDeleteFile(null);
    setFileUrl('');
  }

  // 🟢 Upload through Laravel backend
  const handleUpload = (file) => {
    const extension = file.name.split('.').pop();
    const fileName = `${new Date().getTime()}.${extension}`;

    // Optional image compression
    new Compressor(file, {
      quality: 0.6,
      maxWidth: 900,
      maxHeight: 454,
      success: async (compressedFile) => {
        const fData = new FormData();
        fData.append('image', compressedFile);
        fData.append('filePath', upKey + '/');
        fData.append('content_type', compressedFile.type);

        try {
          const response = await axios.post('/api/upload-image', fData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (evt) => {
              const progressPercentage = parseInt((evt.loaded * 100) / evt.total);
              setProgress(progressPercentage);
            },
          });

          if (response?.data?.url) {
            setFileUrl(response.data.url);
            setFileKey(response.data.Key); // already includes full path
            setProgress(100);
          }
        } catch (err) {
          console.error('Image upload failed:', err);
        }
      },
      error: (err) => {
        console.error('Compression failed:', err);
      },
    });
  };

  if (uploadFile) {
    handleUpload(uploadFile);
    setUploadFile(null);
  }

  return [fileUrl, fileKey, progress];
};

export default useFileHandleS3;
